import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowSplitDown"><Path d="M12 3V12L19 19" stroke="currentColor"/><Path d="M19.5 13V19.5H13" stroke="currentColor"/><Path d="M4.5 19.5L6 18" stroke="currentColor" strokeLinecap="square"/><Path d="M8.25 15.7559L9.75 14.2559" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowSplitDown;
